import script from "./collection-filter-module.vue?vue&type=script&setup=true&lang=js"
export * from "./collection-filter-module.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__